export const UK_DELIVERY_ONLY = 'UK delivery only';
export const SELECTED_COUNTRIES_DELIVERY_ONLY =
  'This brand delivers only to the above listed countries.';
export const FREE_DELIVERY = 'FREE';
export const UK_DROPDOWN_OPTIONS_LABEL = 'United Kingdom';
export const OTHER_COUNTRIES_DROPDOWN_OPTIONS_LABEL = 'Other countries';
export const NO_DELIVERY_OPTIONS_AVAILABLE = `We'll show you the delivery options available once you proceed to checkout.`;
